import {
  FETCH_ACTIVE_PRODUCTS,
  SEARCH_PRODUCTS,
  FETCH_PRICING,
  FETCH_ALL_BRANDS,
  LOADING_FETCH_ALL_BRANDS,
  FETCHING_ACTIVE_PRODUCTS,
} from "../Constants/types";

const initialState = {
  Products: [],
  SearchProducts: [],
  SelectedProductPricing: [],
  isLoadingAllBrand: 0,
  AllBrandsList: [],
  totalProductCount: 0,
  serverProductPage: 1,
  isProductResEmpty: 0,
  isProductsLoading:0,
  fetchProductLoader: true
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_ACTIVE_PRODUCTS:
      if (action.payload.page > 1 && action.payload.results.length) {
        return {
          ...state,
          Products: [...state.Products, ...action.payload.results],
          totalProductCount: action.payload.count,
          serverProductPage: action.payload.page,
          isProductResEmpty: 0,
          fetchProductLoader: false,
		  isProductsLoading:0,
        };
      } else if (action.payload.page == 1 && action.payload.results.length) {
        return {
          ...state,
          Products: action.payload.results,
          totalProductCount: action.payload.count,
          serverProductPage: action.payload.page,
          isProductResEmpty: 0,
          fetchProductLoader: false,
		  isProductsLoading:0,
        };
      } else {
        return {
          ...state,
          Products: action.payload.results,
          totalProductCount: action.payload.count,
          serverProductPage: action.payload.page,
          isProductResEmpty: 1,
          fetchProductLoader: false,
		  isProductsLoading:0,
        };
      }
	case FETCHING_ACTIVE_PRODUCTS:
		return{
				...state,
				isProductsLoading:action.payload,
		}
    case SEARCH_PRODUCTS:
      return {
        ...state,
        SearchProducts: action.payload,
      };
    case FETCH_PRICING:
      return {
        ...state,
        SelectedProductPricing: action.payload,
      };
    case LOADING_FETCH_ALL_BRANDS:
      return { ...state, isLoadingAllBrand: action.payload };
      break;

    case FETCH_ALL_BRANDS:
      return {
        ...state,
        AllBrandsList: action.payload,
        isLoadingAllBrand: 0,
      };
    default:
      return state;
  }
}
